module.exports = __webpack_public_path__ + "static/media/15.9582cd42.jpg";